var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeIco16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM8 10.4648C7.43421 10.4648 7 10.7981 7 11.2324C7.00007 11.6667 7.43425 12 8 12C8.56575 12 8.99993 11.6667 9 11.2324C9 10.7981 8.56579 10.4648 8 10.4648ZM8 4C7.44737 4 7.06594 4.17177 7.0791 4.61621L7.28906 9.23242C7.30226 9.6465 7.64476 9.78809 8 9.78809C8.35524 9.78809 8.69774 9.6465 8.71094 9.23242L8.9209 4.61621C8.93406 4.17177 8.55263 4 8 4Z",
    fill: "#EA5032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeIco16);
export default __webpack_public_path__ + "static/media/Notice_ico_16.93cc9b75a40f12fde9b5aa2740c6fdb5.svg";
export { ForwardRef as ReactComponent };